import React from 'react';
import { LayoutGrid, Heart, Activity, Award, Users } from 'lucide-react';

const ProfileTabs = ({ activeTab, setActiveTab, counts = {}, canViewFullProfile = true, isOwnProfile = false }) => {
  const allTabs = [
    { id: 'overview', label: 'Overview', icon: LayoutGrid },
    { id: 'favorites', label: 'Favorited', icon: Heart, count: counts.favorites },
    { id: 'activity', label: 'Activity', icon: Activity },
    { id: 'badges', label: 'Badges', icon: Award, count: counts.badges },
    { id: 'friends', label: 'Friends', icon: Users, count: counts.friends },
  ];

  // Activity tab only visible on own profile
  // Favorites tab visible for own profile and friends
  let tabs = allTabs;
  
  if (!isOwnProfile) {
    // Remove activity for all non-owner views
    tabs = tabs.filter(tab => tab.id !== 'activity');
  }
  
  if (!canViewFullProfile) {
    // Remove favorites for non-friends
    tabs = tabs.filter(tab => tab.id !== 'favorites');
  }

  return (
    <div className="bg-white/[0.06] backdrop-blur-2xl rounded-2xl border border-white/10 p-1.5 mb-6">
      <div className="flex gap-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl
                transition-all duration-200 text-sm font-medium
                ${isActive
                  ? 'bg-gradient-to-r from-cyan-500/20 to-purple-500/20 text-white border border-cyan-400/30'
                  : 'text-white/60 hover:text-white/80 hover:bg-white/5'
                }
              `}
            >
              <Icon size={18} />
              <span className="hidden sm:inline">{tab.label}</span>
              {tab.count !== undefined && (
                <span className={`
                  text-xs px-2 py-0.5 rounded-full
                  ${isActive ? 'bg-cyan-400/20 text-cyan-300' : 'bg-white/10 text-white/50'}
                `}>
                  {tab.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileTabs;
